define('ROOM4.CCAProductGallery.CCAProductGallery.Model', ['Backbone', 'Utils'], function(
    Backbone,
    Utils
) {
    'use strict';

    return Backbone.Model.extend({
        urlRoot: Utils.getAbsoluteUrl(
            getExtensionAssetsPath('Modules/CCAProductGallery/SuiteScript2/CCAProductGallery.Service.ss'),
            true
        )
    });
});
